import { render, staticRenderFns } from "./candidateSessions.vue?vue&type=template&id=53cdff30&scoped=true"
import script from "./candidateSessions.vue?vue&type=script&lang=js"
export * from "./candidateSessions.vue?vue&type=script&lang=js"
import style0 from "./candidateSessions.vue?vue&type=style&index=0&id=53cdff30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cdff30",
  null
  
)

export default component.exports